import { createBrowserRouter } from "react-router-dom";
import MainLayout from "../layout/MainLayout";

import FlashcardService from "./services/./FlashCards/FlashcardService";
import CategoryService from "./services/./Category/CategoryService";
import ReviewService from "./services/./Reviews/ReviewService";
import CategoryEditPage from "./services/./Category/CategoryEditPage";
import FlashcardEditPage from "./services/./FlashCards/FlashcardEditPage";
import FlashCardCreatePage from "./services/./FlashCards/FlashcardCreatePage";
import QuizTestLayoutMock from "./services/Exam/QuizTestLayoutMock";
import ReviewByCategory from "./services/Reviews/ReviewByCategory";
import ReviewFlashCardScore from "./services/Reviews/ReviewFlashCardScore";
import ReviewByCategoryNoScore from "./services/Reviews/ReviewByCategoryNoScore";
import ReviewFlashCardNoScore from "./services/Reviews/ReviewFlashCardNoScore";
import LoginPage from "../Pages/LoginPage";
import PrivateRoute from "../components/PrivateRoute";
import RegisterPage from "../Pages/RegisterPage";
import ForgotPasswordPage from "../Pages/ForgotPasswordPage";
import ExamMenu from "./services/Exam/ExamMenu";
import ExamByCategory from "./services/Exam/ExamByCategory";
import ExamDetail from "./services/Exam/ExamDetail";
import ExamDetailView from "./services/Exam/ExamDetailView";
import ExamAttemptHistory from "./services/Exam/ExamAttemptHistory";
import Home from "../Pages/Home";
import GenerateImage from "./services/AutoGenerateImage/GenerateImage";
import JobDetailPage from "../Pages/JobDetailPage";
import ReviewDetails from "./services/Reviews/ReviewDetails";

const router = createBrowserRouter([
    // Public
    {
        path: "/login",
        element: <LoginPage />
    },
    {
        path: "/register",
        element: <RegisterPage />
    },
    {
        path: "/forgot-password",
        element: <ForgotPasswordPage />
    },

    // Protected
    {
        element: <PrivateRoute />,   // BỌC BÊN NGOÀI
        children: [
            {
                path: "/",
                element: <MainLayout />,  // LAYOUT CHA CỦA ÔNG
                children: [
                    { path: "/category", element: <CategoryService /> },
                    { path: "/", element: <Home /> },
                    { path: "/category/:id", element: <CategoryEditPage /> },
                    { path: "/flashcard", element: <FlashcardService /> },
                    { path: "/flashcard/:id", element: <FlashcardEditPage /> },
                    { path: "/flashcard/add", element: <FlashCardCreatePage /> },
                    { path: "/review", element: <ReviewService /> },
                    { path: "/review/category", element: <ReviewByCategory /> },
                    { path: "/review/category-no-score", element: <ReviewByCategoryNoScore /> },
                    { path: "/review/flashcard", element: <ReviewFlashCardScore /> },
                    { path: "/review/flashcard-no-score", element: <ReviewFlashCardNoScore /> },
                    { path: "/review/details", element: <ReviewDetails /> },
                    { path: "/exam", element: <ExamMenu /> },
                    { path: "/exam/category", element: <ExamByCategory /> },
                    { path: "/exam/flashcard", element: <ExamDetail /> },
                    { path: "/exam/view", element: <ExamDetailView /> },
                    { path: "/exam/history/:taskId", element: <ExamAttemptHistory /> },
                    { path: "/genimage", element: <GenerateImage /> },
                    { path: "/genimage/job/:jobId", element: <JobDetailPage /> },
                    // { path: "/user", element: <UserService /> }
                ]
            }
        ]
    }
]);


export default router;
